<re-captcha (resolved)="resolved($event)" siteKey="6LdFnUUUAAAAAF-7uSJTiHoU27KONJEOPxqoqisa"></re-captcha>



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/recaptcha/recaptcha.component.html